/*
 * @Descripttion: 我的发票页hooks
 * @Author: cb4786
 * @Date: 2023-08-10 17:39:22
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-01 18:08:23
 */

import { userRouter } from '../../route'
import { history } from '../../redux/store'
import { useEffect, useReducer } from 'react'
import { useQuery } from '../../tools/utilHooks'
import { invoiceState } from '../../components/SearchFilter/TemplateData'
import {
  DELETE_INVOICE_ITEM,
  GET_MY_INVOICE_LIST,
  MyInvoiceItem,
} from '../../api/orderManage'
import { CustomerConfirm } from '../../components/ModalUser'
import { isResponseCodeSuccess, orderTypeData } from '../../tools/util'
import { invoiceNatureEnum } from '@/global/enum'

type ActionType = 'setLoading' | 'setData' | 'setSearchData' | 'changePages'

interface Action {
  type: ActionType
  payload: any
}

interface State {
  dataSource: { data: any[]; total: number; loading: boolean }
  searchdata: any
  pages: {
    pageNo: number
    pageSize: number
  }
}

const initState: State = {
  dataSource: { data: [], total: 100, loading: true },
  searchdata: {},
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setData':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setSearchData':
      // 搜索 重置 分页
      newstate.searchdata = action.payload
      newstate.pages.pageNo = 1
      return newstate
    case 'setLoading':
      newstate.dataSource.loading = action.payload
      return newstate
    case 'changePages':
      newstate.pages = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

const setLoading = (val: boolean): Action => ({
  type: 'setLoading',
  payload: val,
})

/**
 * 设置表格数据
 * @param param
 * @returns
 */
const setData = (param: {
  dataSource: { data: any[]; total: number; loading: boolean }
  pageNo: number
}): Action => ({
  type: 'setData',
  payload: param,
})

// 搜索
const setSearchData = (param: any): Action => ({
  type: 'setSearchData',
  payload: param,
})

// 切换分页
const changePages = (param: { pageNo: number; pageSize?: number }): Action => ({
  type: 'changePages',
  payload: param,
})

// 发票状态
export const getInvoiceState = (state: string) => {
  return invoiceState.find((item) => item.code === state)?.name
}

const UseMyInvoiceHook = () => {
  const supRoute = userRouter[1].url
  const [state, dispatch] = useReducer(reducer, initState)
  const { dataSource, pages } = state
  const query = useQuery()
  const filterType = query.get('type') || ''
  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchData(params))
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 刷新
  const handleTableRefresh = () => {
    getdata(state)
  }

  // 切换分页
  const handlePaginationChange = (pageNo: number, pageSize?: number) => {
    dispatch(
      changePages({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  // 获取表格数据
  const getdata = async (state: State) => {
    dispatch(setLoading(true))
    const params = { ...state.pages, ...state.searchdata }
    const res = await GET_MY_INVOICE_LIST({
      schemeId: params.schemeId || 'all',
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      invoiceNum: params.invoiceNum,
      orderNo: params.orderNo,
      platform: params.platform,
      invoiceState: params.invoiceState,
      supplierOrderCode: params.supplierOrderCode,
      orderSource: params.orderSource,
      invoiceNature: params.invoiceNature,
      returnOrderNo: params.returnOrderNo,
    })
    dispatch(setLoading(false))
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data.content
      const count = res.data.totalCount
      dispatch(
        setData({
          dataSource: { data: resdata, total: count, loading: false },
          pageNo: res.data.pageNo,
        }),
      )
    }
  }

  // 跳转至详情页
  const onJump = (val: MyInvoiceItem) => {
    // 旧数据跳转至对账单详情页
    if (val.accountId) {
      history.replace(`/srm/financialreconciliationdetail?id=${val.accountId}`)
    } else {
      let url = supRoute + '/invoiceDetail'
      if (
        invoiceNatureEnum.isValueInLabels(val.invoiceNature as any, ['红票'])
      ) {
        url = supRoute + '/redInvoiceDetail'
      }

      history.replace({
        pathname: url,
        // 跳转至我的发票详情页
        state: {
          id: val.id,
          // 判断源单类型
          type: orderTypeData.find((item) => item.code === val.orderSource)
            ?.des,
          titleOfTheContract: val.titleOfTheContract,
        },
      })
    }
  }

  // 删除发票单
  const delMyInvoice = async (record: any) => {
    CustomerConfirm({
      title: '您正在删除进项票',
      content: `${
        record.invoiceState === '2'
          ? '您正在删除暂存的发票单，删除后可再次开票，是否删除？'
          : '删除后可重新录入此票，是否确认删除？'
      }`,
      onOk: async () => {
        // 调用接口删除当前暂存的发票单
        const res = await DELETE_INVOICE_ITEM({ invoiceOrderId: record.id })
        if (isResponseCodeSuccess(res.code)) {
          // 获取页面最新数据
          getdata(state)
        }
      },
    })
  }

  useEffect(() => {
    if (filterType === 'rejectInvoice') {
      getdata({
        ...state,
        ...{
          searchdata: { invoiceState: '4' },
        },
      })
    } else {
      getdata(state)
    }
    // eslint-disable-next-line
  }, [])

  return {
    pages,
    dataSource,
    handleSearchClick,
    handleTableRefresh,
    handlePaginationChange,
    onJump,
    delMyInvoice,
  }
}

export default UseMyInvoiceHook
/*
 * @Descripttion: 我的发票页hooks
 * @Author: cb4786
 * @Date: 2023-08-10 17:39:22
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-01 18:08:23
 */

import { userRouter } from '../../route'
import { history } from '../../redux/store'
import { useEffect, useReducer } from 'react'
import { useQuery } from '../../tools/utilHooks'
import { invoiceState } from '../../components/SearchFilter/TemplateData'
import {
  DELETE_INVOICE_ITEM,
  GET_MY_INVOICE_LIST,
  MyInvoiceItem,
} from '../../api/orderManage'
import { CustomerConfirm } from '../../components/ModalUser'
import { isResponseCodeSuccess, orderTypeData } from '../../tools/util'
import { invoiceNatureEnum } from '@/global/enum'

type ActionType = 'setLoading' | 'setData' | 'setSearchData' | 'changePages'

interface Action {
  type: ActionType
  payload: any
}

interface State {
  dataSource: { data: any[]; total: number; loading: boolean }
  searchdata: any
  pages: {
    pageNo: number
    pageSize: number
  }
}

const initState: State = {
  dataSource: { data: [], total: 100, loading: true },
  searchdata: {},
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setData':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setSearchData':
      // 搜索 重置 分页
      newstate.searchdata = action.payload
      newstate.pages.pageNo = 1
      return newstate
    case 'setLoading':
      newstate.dataSource.loading = action.payload
      return newstate
    case 'changePages':
      newstate.pages = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

const setLoading = (val: boolean): Action => ({
  type: 'setLoading',
  payload: val,
})

/**
 * 设置表格数据
 * @param param
 * @returns
 */
const setData = (param: {
  dataSource: { data: any[]; total: number; loading: boolean }
  pageNo: number
}): Action => ({
  type: 'setData',
  payload: param,
})

// 搜索
const setSearchData = (param: any): Action => ({
  type: 'setSearchData',
  payload: param,
})

// 切换分页
const changePages = (param: { pageNo: number; pageSize?: number }): Action => ({
  type: 'changePages',
  payload: param,
})

// 发票状态
export const getInvoiceState = (state: string) => {
  return invoiceState.find((item) => item.code === state)?.name
}

const UseMyInvoiceHook = () => {
  const supRoute = userRouter[1].url
  const [state, dispatch] = useReducer(reducer, initState)
  const { dataSource, pages } = state
  const query = useQuery()
  const filterType = query.get('type') || ''
  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchData(params))
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 刷新
  const handleTableRefresh = () => {
    getdata(state)
  }

  // 切换分页
  const handlePaginationChange = (pageNo: number, pageSize?: number) => {
    dispatch(
      changePages({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  // 获取表格数据
  const getdata = async (state: State) => {
    dispatch(setLoading(true))
    const params = { ...state.pages, ...state.searchdata }
    const res = await GET_MY_INVOICE_LIST({
      schemeId: params.schemeId || 'all',
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      invoiceNum: params.invoiceNum,
      orderNo: params.orderNo,
      platform: params.platform,
      invoiceState: params.invoiceState,
      supplierOrderCode: params.supplierOrderCode,
      orderSource: params.orderSource,
      invoiceNature: params.invoiceNature,
      returnOrderNo: params.returnOrderNo,
    })
    dispatch(setLoading(false))
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data.content
      const count = res.data.totalCount
      dispatch(
        setData({
          dataSource: { data: resdata, total: count, loading: false },
          pageNo: res.data.pageNo,
        }),
      )
    }
  }

  // 跳转至详情页
  const onJump = (val: MyInvoiceItem) => {
    // 旧数据跳转至对账单详情页
    if (val.accountId) {
      history.replace(`/srm/financialreconciliationdetail?id=${val.accountId}`)
    } else {
      let url = supRoute + '/invoiceDetail'
      if (
        invoiceNatureEnum.isValueInLabels(val.invoiceNature as any, ['红票'])
      ) {
        url = supRoute + '/redInvoiceDetail'
      }

      history.replace({
        pathname: url,
        // 跳转至我的发票详情页
        state: {
          id: val.id,
          // 判断源单类型
          type: orderTypeData.find((item) => item.code === val.orderSource)
            ?.des,
          titleOfTheContract: val.titleOfTheContract,
        },
      })
    }
  }

  // 删除发票单
  const delMyInvoice = async (record: any) => {
    CustomerConfirm({
      title: '您正在删除进项票',
      content: `${
        record.invoiceState === '2'
          ? '您正在删除暂存的发票单，删除后可再次开票，是否删除？'
          : '删除后可重新录入此票，是否确认删除？'
      }`,
      onOk: async () => {
        // 调用接口删除当前暂存的发票单
        const res = await DELETE_INVOICE_ITEM({ invoiceOrderId: record.id })
        if (isResponseCodeSuccess(res.code)) {
          // 获取页面最新数据
          getdata(state)
        }
      },
    })
  }

  useEffect(() => {
    if (filterType === 'rejectInvoice') {
      getdata({
        ...state,
        ...{
          searchdata: { invoiceState: '4' },
        },
      })
    } else {
      getdata(state)
    }
    // eslint-disable-next-line
  }, [])

  return {
    pages,
    dataSource,
    handleSearchClick,
    handleTableRefresh,
    handlePaginationChange,
    onJump,
    delMyInvoice,
  }
}

export default UseMyInvoiceHook
